import React, { useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Button from '../../../../common/components/Button/Button';
import InsurerDetailsForm from '../BrandDetailsForm/BrandDetailsForm';
import CloneSchemesForm from '../CloneSchemesForm/CloneSchemesForm';
import './BrandListItem.scss';

const BrandListItem = ({ insurer, productId, insurerSchemes, onRefreshInsurerPage }) => {
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [showEditInfoModal, setShowEditInfoModal] = useState(false);
  const [showCloneSchemesModal, setShowCloneSchemesModal] = useState(false);

  const toggleInsurerInfo = () => {
    setShowMoreInfo(!showMoreInfo);
  };

  const handleEditInsurerInfo = () => {
    setShowEditInfoModal(true);
  };

  const handleCloseEditInsurerInfo = () => {
    setShowEditInfoModal(false);
  };

  const handleOpenCloneSchemeModal = () => {
    setShowCloneSchemesModal(true);
  };

  const handleCloseCloneSchemeModal = () => {
    setShowCloneSchemesModal(false);
  };

  return (
    <>
      <div
        onClick={toggleInsurerInfo}
        className={`brand-list-item--section ${
          !showMoreInfo ? 'section-collapsed' : 'section-open'
        }`}
      >
        <div className="brand-list-item--insurer-logo">
          <img src={insurer.attributes.logo} alt="Missing logo" />
        </div>
        <div className="brand-list-item--insurer-content">
          {showMoreInfo && (
            <div className="animated fadeIn">
              <div>
                <Row>
                  <Col sm={12}>
                    <div className="margin-top-15 padding-2">
                      Name:
                      <br />
                      <strong>{insurer.attributes.name}</strong>
                    </div>
                    <div className="margin-top-15 padding-2">
                      Agreement Number:
                      <br />
                      <strong>{insurer.attributes.agreement_number}</strong>
                    </div>
                    <div className="margin-top-15 padding-2">
                      Carry Broker Risk:
                      <br />
                      <strong>
                        {insurer.attributes.carry_broker_risk ? 'Yes' : 'No'}
                      </strong>
                    </div>
                    <div className="margin-top-15 margin-bottom-15 padding-2">
                      Max Brokerage:
                      <br />
                      <strong>
                        {insurer.attributes.max_commission &&
                          `${insurer.attributes.max_commission}%`}
                      </strong>
                    </div>
                  </Col>
                  <Col sm={12} className="button">
                    <div className="btn-bar">
                      <Button
                        bsStyle="primary"
                        link={true}
                        to={`/admin/products/${productId}/insurers/${insurer.id}/schemes`}
                      >
                        View Schemes
                      </Button>
                    </div>
                  </Col>
                  <Col
                    sm={12}
                    className={`button margin-top-10 ${
                      insurerSchemes && insurerSchemes.length === 0
                        ? ''
                        : 'margin-bottom-15'
                    }`}
                  >
                    <div className="btn-bar">
                      <Button
                        bsStyle="primary"
                        className=" pull-right btn-blue"
                        handleClick={handleEditInsurerInfo}
                      >
                        Edit Brand Details
                      </Button>
                    </div>
                  </Col>
                  {insurerSchemes && insurerSchemes.length === 0 && (
                    <Col sm={12} className="button margin-top-10 margin-bottom-15">
                      <div className="btn-bar">
                        <Button
                          bsStyle="primary"
                          className=" pull-right btn-blue"
                          handleClick={handleOpenCloneSchemeModal}
                        >
                          Clone Existing Brand's Schemes
                        </Button>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal show={showEditInfoModal} onHide={handleCloseEditInsurerInfo}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Brand Details</Modal.Title>
        </Modal.Header>
        {showEditInfoModal && (
          <InsurerDetailsForm
            insurer={insurer}
            onClose={handleCloseEditInsurerInfo}
            onRefreshInsurerPage={onRefreshInsurerPage}
          />
        )}
      </Modal>
      <Modal show={showCloneSchemesModal} onHide={handleCloseCloneSchemeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Clone Schemes</Modal.Title>
        </Modal.Header>
        {showCloneSchemesModal && (
          <CloneSchemesForm
            insurerName={insurer.attributes.name}
            insurerId={insurer.id}
            productId={productId}
            insurer={insurer}
            onClose={handleCloseCloneSchemeModal}
            onRefreshInsurerPage={onRefreshInsurerPage}
          />
        )}
      </Modal>
    </>
  );
};

export default BrandListItem;
